import React, { PureComponent } from "react";
import { Link } from "react-router-dom";
import { getToken, getCurrentUser } from 'utils/storage';
import Request from "../../networkReq/request";
import Http from "../../networkReq/http"
import { Base64 } from 'js-base64';
import { getRecord, setRecord } from '../../utils/storage';
import {
  removeAll,
} from 'utils/storage';

import { MessageBox, Message } from 'element-react';

export default class Header extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      token: null,
      user: '',
    };

  }

  componentDidMount() {
    if(getToken()){
      this.getUserInfo();
    }
    
  }


  getUserInfo() {
    const token = getToken();
   
    fetch(Request.personaluserInfo(), {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/x-www-form-urlencoded",
        "Blade-Auth": token,
      }),
      body: {}
    })
      .then(response => response.json())
      .then(responseJson => {
        if (responseJson.code == 200) {
          const user = getCurrentUser();
          console.log("==========",responseJson);
          this.setState({
            token: token,
            user: responseJson.data.user
          })
        }else {
          removeAll()
        }
      })
      .catch(e => {

        const status = e.name;
        console.log('status', status)

      });

  }

  goDetail(url) {
    this.props.history.push(url)
  }
  logOut() {
    let{zwwcom,zwwlogout,clientId,logouttourl}=Request.getZwwConfig();
    MessageBox.confirm('确定要退出登录吗？', '提示').then(() => {
      removeAll();
      this.setState({
        token: null,
        user: ''
      }, () => {
        var resulturl=zwwcom+zwwlogout+"?utype=0&goto="+logouttourl+"&client_id="+clientId;
        console.log("退出地址："+resulturl);
        window.location=resulturl;
        Message({
          type: 'success',
          message: '退出成功!'
        });
      })
      // this.props.history.push('/entrance/home')


    })
  }

  handClickMsg(e) {
    Message.error("正在开发中");
  }


  renderLogin() {
    return (
      <div> 
          <a className="top-head-a" onClick={() => this.register()}>注册</a>               
          <a className="top-head-a" onClick={() => this.tologin()}>登录</a>               
          <a className="top-head-a" to="/">部门网站导航</a>              
      </div>
    )
  }
 random4  () {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
};
createUUID  () {
    return (this.random4() + this.random4() + this.random4() + this.random4() + this.random4() + this.random4());
};
register(){
  let { zwwcom,zwwRegister,clientId} =Request.getZwwConfig();
  let goto={};
  goto.url='/entrance/home'
  goto.uuid=this.createUUID();
  let  gototmp=  JSON.stringify(goto);
  let  gotoencode=  Base64.encode(gototmp);
  setRecord(goto);
  window.location=zwwcom+zwwRegister+"?utype=0&goto="+gotoencode+"&client_id="+clientId;
}
  tologin(){
    let { zwwcom,zwwlogin,clientId,devredirectUrl,prodredirectUrl} =Request.getZwwConfig();
    let goto={};
    goto.url='/entrance/home'
    goto.uuid=this.createUUID();
    // if(window.location.hostname=='localhost'||window.location.hostname=='127.0.0.1'||window.location.hostname=='yhbest.imwork.net'){
    //   goto.redirectUrl=devredirectUrl;
    // }else if(window.location.hostname=='10.12.22.83'||window.location.hostname=='12.12.12.1'){
    //   goto.redirectUrl=prodredirectUrl;
    // }else{
    //   goto.redirectUrl=devredirectUrl;
    // }
    goto.redirectUrl=prodredirectUrl;
   
    let  gototmp=  JSON.stringify(goto);
    let  gotoencode=  Base64.encode(gototmp);
    setRecord(goto);
    window.location=zwwcom+zwwlogin+"?utype=0&goto="+gotoencode+"&client_id="+clientId;
  }
  
  renderLogOut() {
    let { user } = this.state;
    return (
      <div>        
          <a className="top-head-a">欢迎您:   {user.name}</a>               
          <Link className="top-head-a" to={{ pathname: '/entrance/main' }}>个人中心</Link>               
          <a className="top-head-a" onClick={() => this.logOut()} >退出登录</a>               
          <a className="top-head-a" to="/">部门网站导航</a>              
      </div>
    )
  }
  render() {
    let { token, user } = this.state;
    return (
      <div>
         {!user ? this.renderLogin() : this.renderLogOut()}
      </div>
    );
  }
}
